import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age',
  standalone: true,
})
export class AgePipe implements PipeTransform {
  transform(value: Date | string): number {
    if (!value) {
      return 0;
    }

    const birthDate = value instanceof Date
      ? value
      : new Date(value);

    if (isNaN(birthDate.getTime())) {
      throw new Error('Invalid date provided');
    }

    const currentDate = new Date();

    // Calculate full years
    let age = currentDate.getFullYear() - birthDate.getFullYear();

    // Adjust if birthday hasn't occurred this year
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();
    const dayDiff = currentDate.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    // Calculate the fractional part more precisely
    const nextBirthday = new Date(birthDate);
    nextBirthday.setFullYear(currentDate.getFullYear());

    // If birthday already passed this year, set to next year
    if (nextBirthday <= currentDate) {
      nextBirthday.setFullYear(currentDate.getFullYear() + 1);
    }

    const lastBirthday = new Date(nextBirthday);
    lastBirthday.setFullYear(nextBirthday.getFullYear() - 1);

    const totalYearMs = nextBirthday.getTime() - lastBirthday.getTime();
    const passedMs = currentDate.getTime() - lastBirthday.getTime();

    const preciseAge = age + (passedMs / totalYearMs);

    return Math.round(preciseAge * 10) / 10;
  }

}
